import axios, { AxiosResponse } from 'axios'
import {
  PageResponseHistoricoValorEmpresaList,
  PageResponseValorEmpresaList,
  ValorEmpresaDtoCadastrar,
  ValorEmpresaDtoRemover,
  ValorEmpresaList,
  ValorEmpresaView,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL

const EMPRESA_VALORES_URL = `${API_URL}/financeiro/empresa`
const EMPRESA_HISTORICO_VALORES_URL = `${API_URL}/financeiro/empresa/historico`

/**
 * Busca valores de cliente
 * @param query string
 * @param idEmpresa ID da Empresa
 * @returns ValorEmpresaList
 */
export const getValoresEmpresa = (
  query: string,
  idEmpresa: number
): Promise<PageResponseValorEmpresaList> => {
  return axios
    .get(`${EMPRESA_VALORES_URL}/${idEmpresa}?${query}`)
    .then((d: AxiosResponse<PageResponseValorEmpresaList>) => d.data)
}

/**
 * Busca um valor de cliente
 * @param idEmpresa ID da Empresa
 * @param idValor ID do valor
 * @returns ValorEmpresaView
 */
export const getValoresEmpresaByValor = (
  idEmpresa: number,
  idValor: number
): Promise<ValorEmpresaView> => {
  return axios
    .get(`${EMPRESA_VALORES_URL}/${idEmpresa}/${idValor}`)
    .then((d: AxiosResponse<ValorEmpresaView>) => d.data)
}

/**
 * Cadastra valores de cliente
 * @param idEmpresa ID da Empresa
 * @param data ValorEmpresaDtoCadastrar
 * @returns ValorEmpresaList
 */
export const createValoresByEmpresa = (
  idEmpresa: number,
  data: ValorEmpresaDtoCadastrar
): Promise<ValorEmpresaList> => {
  return axios
    .post(`${EMPRESA_VALORES_URL}/${idEmpresa}`, data)
    .then((d: AxiosResponse<ValorEmpresaList>) => d.data)
}

/**
 * Remove valores de cliente
 * @param idEmpresa ID da Empresa
 * @param data ValorEmpresaDtoRemover
 * @returns ValorEmpresaList[]
 */
export const deleteValoresByEmpresa = (
  idEmpresa: number,
  data: ValorEmpresaDtoRemover
): Promise<ValorEmpresaList[]> => {
  return axios
    .delete(`${EMPRESA_VALORES_URL}/${idEmpresa}`, { data })
    .then((d: AxiosResponse<ValorEmpresaList[]>) => d.data)
}

/**
 * Busca histórico de valores
 * @param query string
 * @param idEmpresa ID da Empresa
 * @returns HistoricoValorEmpresaList
 */
export const getHistoricoValoresEmpresa = (
  query: string,
  idEmpresa: number
): Promise<PageResponseHistoricoValorEmpresaList> => {
  return axios
    .get(`${EMPRESA_HISTORICO_VALORES_URL}/${idEmpresa}?${query}`)
    .then((d: AxiosResponse<PageResponseHistoricoValorEmpresaList>) => d.data)
}
